<template>
  <div>
    <nuxt />
  </div>
</template>

<script>
export default {
  name: 'Temp'
}
</script>

<style scoped>

</style>
